import { Row } from '@opendoor/atoms/box';
import { Button } from '@opendoor/atoms/button';
import { Dialog } from '@opendoor/atoms/dialog';
import { Text } from '@opendoor/atoms/text';

const ExitOfferDialog = ({
  open,
  leaving,
  error,
  onStay,
  onLeave,
}: {
  open: boolean;
  leaving: boolean;
  error: string | null;
  onStay: () => void;
  onLeave: () => Promise<void>;
}) => {
  const handleOpenChange = (nextOpen: boolean) => {
    if (!nextOpen) onStay();
  };

  return (
    <Dialog.Root role="dialog" open={open} onOpenChange={handleOpenChange}>
      <Dialog title="Abandon offer" size="sm">
        <Dialog.Description className="text-body-md text-od-content-secondary">
          Your offer hasn’t been submitted. Details entered on this page will not be saved.
        </Dialog.Description>
        {error ? (
          <Text role="alert" className="pt-3 text-body-sm text-od-content-error">
            {error}
          </Text>
        ) : null}
        <Row className="flex-wrap justify-end gap-2 pt-6">
          <Button
            type="button"
            variant="secondary"
            size="md"
            onClick={onStay}
            disabled={leaving}
            aria-label="Cancel"
            analyticsName="cosmos-make-offer-cancel-exit"
          >
            Cancel
          </Button>
          <Button
            type="button"
            variant="destructive"
            size="md"
            onClick={onLeave}
            disabled={leaving}
            loading={leaving}
            aria-label="Abandon offer"
            analyticsName="cosmos-make-offer-confirm-exit"
          >
            Abandon offer
          </Button>
        </Row>
      </Dialog>
    </Dialog.Root>
  );
};

export default ExitOfferDialog;
